import type {ReactElement} from 'react';
import React from 'react';
import useDefaultPanelClose from '@Panels/hooks/useDefaultPanelClose';
import {Panel, PanelHeader} from '@Components/panel';
import {useUpdateEffect} from 'ahooks';
import {ItemOpacityOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-opacity-option';
import {ContextualMenu} from '@Components/contextual-menu';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';

interface PosterEditorItemOpacityPanelProps {
  panelId: string;
}

export default function PosterEditorItemOpacityPanel({...props}: PosterEditorItemOpacityPanelProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const onClose = useDefaultPanelClose(props.panelId);

  useUpdateEffect((): void => {
    onClose();
  }, [activeItemId]);

  const getHeader = (): ReactElement<any> => {
    return <PanelHeader onClose={onClose} title={window.i18next.t('pmwjs_opacity')} />;
  };

  const getContent = (): ReactElement<any> => {
    return (
      <ContextualMenu id="item-opacity-mobile-panel" hasMobileModalPadding>
        {activeItem !== null ? <ItemOpacityOption /> : null}
      </ContextualMenu>
    );
  };

  return <Panel panelHeader={getHeader()} panelContent={getContent()} />;
}
